import * as Cookies from "js-cookie";

const NEWOBJECTS_KEY = 'newobjectIdsUserOpenedPhoneIn';
const OFFERS_KEY = 'offerIdsUserOpenedPhoneIn';
const TIME_POPUP_STARTED_SHOWING_KEY = 'timeCallNowPopupStartedShowing';
const COUNT_POPUP_SHOWED = 'countCallNowPopupShowed';


export function saveNewobjectIdUserOpenedPhoneIn(newobjectId: number): void {
  saveIdInStorage(NEWOBJECTS_KEY, newobjectId);
}

export function saveOfferIdUserOpenedPhoneIn(offerId: number): void {
  saveIdInStorage(OFFERS_KEY, offerId);
}

export function isUserOpenedPhoneInOffer(offerId: number): boolean {
  return existInStorage(OFFERS_KEY, offerId);
}

export function isUserOpenedPhoneInNewobject(newobjectId: number): boolean {
  return existInStorage(NEWOBJECTS_KEY, newobjectId);
}

export function incrementCountPopupShowed() {
  const { count, timeStarted } = getOrCreateHistoryPopupShowedCookie(); 

  createCountPopupShowedCookie(count + 1, timeStarted);
}

export function getCountPopupShowed() {
  const { count } = getOrCreateHistoryPopupShowedCookie();
  
  return count;
}

// Проверяем можно ли показывать баннер
// например, не превышает ли текущее количество показов 2 в сутки 
export function isShowingsLimitReached(countLimit: number, hoursLimit: number) {
  const { count, timeStarted } = getOrCreateHistoryPopupShowedCookie();
  const hoursBetween = (Date.now() - timeStarted) / 36e5;

  return !(count < countLimit && hoursBetween < hoursLimit);
}

export function isPopupHistoryExpired(hours: number):boolean {
  const timeNow = Date.now();
  const { timeStarted } = getOrCreateHistoryPopupShowedCookie(); 

  return (timeNow - timeStarted) / 36e5 >= hours;
}

export function resetPopupShowingsHistory() {
  createCountPopupShowedCookie(0, Date.now());
}

function getOrCreateHistoryPopupShowedCookie() {
  const cookieValue = Cookies.get(COUNT_POPUP_SHOWED);
  const isValid = /\d:\d+/.test(cookieValue);
  
  if (isValid) {
    const pair = cookieValue.split(':');

    return {
      count: Number(pair[0]),
      timeStarted: Number(pair[1])
    }
  }

  const count = 0;
  const timeStarted = Date.now();

  createCountPopupShowedCookie(count, timeStarted);

  return { count, timeStarted };
}

function createCountPopupShowedCookie(count:number, timeStarted:number) {
  Cookies.set(COUNT_POPUP_SHOWED, `${count}:${timeStarted}`, { expires: 365, path: '/', domain: '.cian.ru' })
}

function existInStorage(key: string, value: number): boolean {
  if (!value || !window.localStorage || !window.localStorage.getItem) {
    return false;
  }

  try {
    const item = window.localStorage.getItem(key);
    const json: number[] | void = JSON.parse(item);
    return Array.isArray(json) && json.indexOf(value) >= 0;
  } catch (err) {
    window.localStorage.removeItem(key);
    return false;
  }
}

function saveIdInStorage(key: string, value: number): void {
  if (!value || !window.localStorage || !window.localStorage.getItem) {
    return null;
  }

  let json: number[] | void = JSON.parse(window.localStorage.getItem(key));
  let res: string = '';

  if (!json || !Array.isArray(json)) { 
    res = JSON.stringify([value]);
  } else if (json.indexOf(value) >= 0) {
    return;
  } else {
    json.push(value);
    res = JSON.stringify(json);
  }

  try {
    window.localStorage.setItem(key, res);
  } catch (err) {
    window.localStorage.removeItem(key);
  }
}


// WEBPACK FOOTER //
// ./src/utils/call_now.ts